/* eslint-disable @typescript-eslint/no-explicit-any */
import { RootState } from 'app/store';
import { get } from 'lodash';

export const select_InfoCustomer_selector = (state: RootState): InfoCustomerITF | null =>
  get(state, 'thongTinTaiKhoanReducer.infoCustomer', {});